import React from "react";
import Context from "../../../../context";
import Components from "./Components";

import { ICreateAndUpdateSchool } from "../../../../types/school.interface";
import { CustomIcon, CustomModal } from "../../../../components";

import "./index.sass";
import { useTranslation } from "react-i18next";

const Create = () => {
  // ** ===========================================================================================================
  // **                                          Values Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, createFunction } = React.useContext(
    Context.SchoolScreen
  );
  const [formData, setFormData] = React.useState<ICreateAndUpdateSchool>({});
  const [step, setStep] = React.useState<number>(1);

  // ** ===========================================================================================================
  // **                                            Local Functions
  // ** -----------------------------------------------------------------------------------------------------------
  function onBack(event: ICreateAndUpdateSchool) {
    setFormData({ ...formData, ...event });
    setStep(step - 1);
  }

  function onNext(event: ICreateAndUpdateSchool) {
    setFormData((prevFormData: ICreateAndUpdateSchool) => ({
      ...prevFormData,
      ...event,
    }));
    setStep(step + 1);
  }

  function onSubmit(event: ICreateAndUpdateSchool): void {
    createFunction!({ ...formData, ...event });
  }

  function RenderCreateSchool() {
    switch (step) {
      case 1:
        return (
          <Components.SchoolInformation
            defaultValues={formData}
            onSubmit={onNext}
          />
        );
      case 2:
        return (
          <Components.TimingInformation
            defaultValues={formData}
            onSubmit={onSubmit}
            onBack={onBack}
          />
        );
      default:
        return null;
    }
  }

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  return (
    <section id="school-create-modal-container">
      <CustomIcon
        icon="fa-sharp fa-solid fa-circle-plus"
        size="medium"
        hoverTitle={t("createSchool")}
        onClick={() => {
          setShowModal("CREATE");
        }}
      />
      <CustomModal
        onClose={() => setShowModal("NONE")}
        open={showModal === "CREATE"}
      >
        <RenderCreateSchool />
      </CustomModal>
    </section>
  );
};

export default Create;
